// @ts-ignore
import { RequestParams, ResponseResult, ResponseErrorResult } from '@/interface/request.interface'
import message from '@/shared/message'
// @ts-ignore
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { vm } from '@/main'
import storage from '@/shared/storage'
import { getType } from '@/shared/untils'
import moment from 'moment'
import router from '@/router'

let ifSetServerYear = true

const developmentPath: string = process.env.VUE_APP_IS_MOCK === 'true' ? '' : '/api_service'
const axiosInst: AxiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? developmentPath : '',
  headers: {
    'Content-Type': 'application/json',
  },
})

function GET(url: string, params: Record<string, any>, config: AxiosRequestConfig): Promise<AxiosResponse> {
  return axiosInst.get(url, { params: params, ...config })
}

function POST(
  url: string,
  params: Record<string, any>,
  config: AxiosRequestConfig,
  paramUseData: boolean,
  origParams: object
): Promise<AxiosResponse> {
  if (paramUseData) {
    ;(origParams as FormData).append('header', JSON.stringify(params.header))
    return axiosInst.post(url, origParams, config)
  }
  return axiosInst.post(url, params, config)
}

async function requestShunt(options: RequestParams, paramUseData: boolean, origParams: object): Promise<AxiosResponse> {
  const { url, params = {}, config = {}, method = 'POST', noParamKey } = options

  if (options.url.includes('v1/UploadImage') || options.url.includes('/v1/uploadRecord')) {
    config.headers = {
      'Content-Type': 'multipart/form-data',
    }
  }
  switch (method.toUpperCase()) {
    case 'GET':
      return await GET(url, params, config)
    case 'POST':
      return await POST(url, noParamKey ? params.param : params, config, paramUseData, origParams)
    default:
      throw new Error('[js报错]: 没有找到对应的method请求。')
  }
}

// 转换错误的数据结构
function processedLogicErrorContent(err: ResponseResult<any>): ResponseErrorResult {
  let { message } = err
  const { code } = err
  if (code === 10048) {
    message = ''
  }
  return { code, message, rawMessage: null, rawError: err }
}

// 转换错误的数据结构
function processedRawErrorContent(err: AxiosError): ResponseErrorResult {
  const { message, response } = err
  // 请求时原生错误不带status时，以-1作为code
  const { status } = response || { status: -1 }
  let errorMsg
  switch (String(status)[0]) {
    case '4':
      errorMsg = `请求发生异常，错误代码：${status}`
      break
    case '5':
      errorMsg = `服务端异常，错误代码：${status}`
      break
    default:
      errorMsg = `未知异常，错误代码：${status}`
  }
  return { code: status, message: errorMsg, rawMessage: message, rawError: err }
}

async function service<ResponseResultData>(options: RequestParams, paramUseData: boolean): Promise<any> {
  type resultType = ResponseResult<ResponseResultData>
  try {
    const account = vm.$store.getters.getAccount
    // 后端要求先写死
    account.platform = 1
    if (!account.requestId) account.requestId = 0
    ++account.requestId
    if (options.url === '/api/v1/login') {
      delete account.ext
      if (options.params && options.params.type !== undefined && options.params.type === 0) {
        delete account.token
      }
    }
    const params = options.params

    if (options.method !== 'GET') {
      if (paramUseData && !options.noHeader) {
        options.params = {
          header: { ...account },
        }
      } else {
        options.params = {
          param: params,
        }
        if (!options.noHeader) {
          options.params.header = { ...account }
        }
      }
    }
    const response: AxiosResponse<resultType> = await requestShunt(options, paramUseData, params || {})

    const { data: axiosResp, headers }: AxiosResponse<resultType> = response

    if (ifSetServerYear) {
      // 获取服务端年份
      vm.$store.commit('setServerYear', moment(headers.date).year())
      ifSetServerYear = false
    }
    // 设置累加的requestId
    vm.$store.commit('setAccount', account)
    const { code, data }: resultType = axiosResp

    if (options.url.includes('/outplay/api/start') || options.url.includes('/grow/api/start')) {
      // 特殊处理ai机器人接口
      return axiosResp
    }
    // 业务逻辑错误
    if (code !== 0) throw axiosResp

    if (options.method === 'GET' && options.url.includes('reply/auth')) {
      return axiosResp
    }
    if (getType(data) === 'object' && data !== null && Reflect.has(data, 'rsp') && options.url !== '/api/v1/login') {
      return (data as any).rsp
    }
    if (options.method === 'GET' || data !== null || options.url === '/api/v1/login') {
      return data
    }

    return response
  } catch (e) {
    const isRawError = !!(e as any).response
    const errorResult: ResponseErrorResult = isRawError
      ? processedRawErrorContent(e as any)
      : processedLogicErrorContent(e as any)
    // 登录超时处理
    if ((e as any).code === 10012) {
      storage.delete('account')
      router.push({ name: 'login' })
    }
    throw errorResult
  }
}

const ignoreCode = [10093, 10076, 10017]

async function request<ResponseResultData>(
  options: RequestParams,
  { showLoading = true, showMsg = true, paramUseData = false } = {}
): Promise<any> {
  try {
    showLoading && vm.$store.commit('setLoading', true)
    return await service<ResponseResultData>(options, paramUseData)
  } catch (e: any) {
    if (e.code === 10019) {
      if ('/login' === window.location.pathname) {
        showMsg && (e as any).message && message.error((e as any).message)
        return
      } else {
        router.push({ name: 'login' })
        return
      }
    }
    if (ignoreCode.includes((e as any).code)) {
      throw e
    } else {
      showMsg && (e as any).message && message.error((e as any).message)
      throw e
    }
  } finally {
    showLoading && vm && vm.$store.commit('setLoading', false)
  }
}

export default request
